import { nip19 } from 'nostr-tools';

/**
 * Generate a short, human-friendly fallback name for a pubkey that has no
 * profile metadata. Derived from the npub so it is stable per user.
 */
export function genUserName(pubkey: string): string {
  try {
    const npub = nip19.npubEncode(pubkey);
    return `${npub.slice(0, 8)}…${npub.slice(-4)}`;
  } catch {
    return `${pubkey.slice(0, 8)}…`;
  }
}
